import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { SubtitlesService } from "../core";

@Component({
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit, OnChanges {
    @Output() dateChange = new EventEmitter<string>();
    @Input() newDate: string = '';
    @Input() small: true | undefined = undefined;
    @Input() showYear: boolean = true;
    @Input() disabled: boolean = false;

    currentYear: number;
    currentMonth: number;
    today: number | null = null;
    selectedDay: number | null = null;
    weeks: { day: number, currentMonth: boolean }[][] = [];
    date = new Date();

    ngOnInit(): void {
        this.today = this.date.getDate();
        if (!this.newDate) {
            this.currentYear = this.date.getFullYear();
            this.currentMonth = this.date.getMonth();
            this.generateCalendar(this.currentYear, this.currentMonth);
        }
    }

    constructor(private subtitles: SubtitlesService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['newDate'] && changes['newDate'].currentValue) {
            const selectedDate = new Date(changes['newDate'].currentValue);
            if (!isNaN(selectedDate.getTime())) {
                this.currentYear = selectedDate.getFullYear();
                this.currentMonth = selectedDate.getMonth();
                this.selectedDay = selectedDate.getDate();
                this.generateCalendar(this.currentYear, this.currentMonth);
            }
            this.date = new Date();
        }
    }

    generateCalendar(year: number, month: number): void {
        const firstDayOfMonth = new Date(year, month, 1);
        let firstDayOfWeek = firstDayOfMonth.getDay();
        firstDayOfWeek = (firstDayOfWeek + 6) % 7;

        const lastDayOfMonth = new Date(year, month + 1, 0);
        const lastDate = lastDayOfMonth.getDate();
        const daysInLastMonth = new Date(year, month, 0).getDate();

        let dayCounter = 1;
        let previousMonthDayCounter = daysInLastMonth - firstDayOfWeek + 1;
        this.weeks = [];

        for (let week = 0; week < 6; week++) {
            const days: { day: number, currentMonth: boolean }[] = [];
            let weekContainsCurrentMonthDays = false;

            for (let day = 0; day < 7; day++) {
                if (week === 0 && day < firstDayOfWeek) {
                    days.push({
                        day: previousMonthDayCounter++,
                        currentMonth: false
                    });
                } else if (dayCounter > lastDate) {
                    days.push({
                        day: dayCounter++ - lastDate,
                        currentMonth: false
                    });
                } else {
                    days.push({day: dayCounter++, currentMonth: true});
                    weekContainsCurrentMonthDays = true;
                }
            }

            if (weekContainsCurrentMonthDays || week < 4) {
                this.weeks.push(days);
            } else {
                break;
            }
        }
    }

    changeMonthBy(offset: number): void {
        this.currentMonth += offset;
        if (this.currentMonth > 11) {
            this.currentMonth = 0;
            this.currentYear++;
        } else if (this.currentMonth < 0) {
            this.currentMonth = 11;
            this.currentYear--;
        }
        this.generateCalendar(this.currentYear, this.currentMonth);
        this.date = new Date();
    }

    selectDay(day: number, currentMonth: boolean): void {
        if (!currentMonth) {
            if (day < 15) {
                this.changeMonthBy(1);
            } else {
                this.changeMonthBy(-1);
            }
        }
        this.selectedDay = day;
        this.date = new Date();
        const formattedDate = `${this.currentYear}-${this.double(this.currentMonth + 1)}-${this.double(day)}`;
        this.dateChange.emit(formattedDate);
    }

    double(value: number): string {
        return value < 10 ? `0${value}` : `${value}`;
    }

    getMonthName(month: number): string {
        const monthName: number[] = [
            1010, 1011, 1012, 1013, 1014, 1015,
            1016, 1017, 1018, 1019, 1020, 1021
        ];
        return this.subtitles.setSubtitle(monthName[month]);
    }

    getDaysName(): string[] {
        return [
            this.subtitles.setSubtitle(590),
            this.subtitles.setSubtitle(894),
            this.subtitles.setSubtitle(708),
            this.subtitles.setSubtitle(235),
            this.subtitles.setSubtitle(516),
            this.subtitles.setSubtitle(703),
            this.subtitles.setSubtitle(445),
        ];
    }
}
